import { render, staticRenderFns } from "./ProjectsSidebar.vue?vue&type=template&id=025fc02c&"
import script from "./ProjectsSidebar.vue?vue&type=script&lang=ts&"
export * from "./ProjectsSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectsSidebar.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports